// Pendiente de revisar
import { SortDirection } from "@/shared/enums/catalogue-search-filter-type";
import { SortTypeBy } from "../enums/column-sort-order";

export interface SortQueryOptions {
	page?: number;
	size?: number;
	sort?: SortDirection;
	sortBy?: SortTypeBy;
}

export function buildQueryOptions(opts?: SortQueryOptions): string {
	if (!opts) return "";

	const params: Record<string, string> = {};

	if (opts.page != null) params.page = String(opts.page);
	if (opts.size != null) params.size = String(opts.size);
	if (opts.sort) params.sort = opts.sort;
	if (opts.sortBy) params.sortBy = opts.sortBy;

	const qs = new URLSearchParams(params).toString();
	return qs ? `?${qs}` : "";
}

export type RowsLike<T> = T[] | { content: T[] } | { columns: T[] };

export function toRows<T>(resp: RowsLike<T>): T[] {
	if (Array.isArray(resp)) return resp;
	if ("content" in resp) return resp.content;
	if ("columns" in resp) return resp.columns;
	return [];
}
